module.exports = __webpack_public_path__ + "assets/img/currency.5d17fdd7.png";